const config = {
  clientName: "OXRED",
  imagePath: "media/datakrew/oxred/oxred.png",
  svgPath: "media/datakrew/oxred/oxred.svg",
  logoSVGPath: "media/datakrew/oxred/oxred-logo.svg",
  faviconIcon: "media/datakrew/oxred/oxred-logo.png",
  pages: {
    signIn: {
      componentName: "OxredSignIn",
      componentPath: "views/domains/oxred/OxredSignIn",
      email: ["admin@datakrew.com", "spp770011@tatamotors.com"],
      password: ["datakrew", "oxredtatamotors"],
    },
  },
};

export default config;
1;
